// extracted by mini-css-extract-plugin
module.exports = {"container":"SharesLiquidityAnswer_container__jJPNI","link":"SharesLiquidityAnswer_link__GmWjl"};